<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div class="meinmenu_title">
            <div>はじめてご利用の業者様へ</div>
            <div>特別仕切り価格のご案内</div>
          </div>
          <p class="guide_title_msg">
            mm/styleは、従来の規格サイズの収納家具では解決できない、「お部屋の間取りにピッタリ合わせた収納家具が欲しい」というお客様の要望を叶える収納家具を販売する専門サイトです。<br>
            トイレや洗濯機上の吊戸棚（フロート収納）、テレビボード、食器棚（カップボード）、壁面収納など、あらゆる住居空間の収納を取り揃えております。<br>
            <br>
            400社を超える業者様にご利用をいただいております。オーダー収納家具のご提供は、安心してmm/styleにお任せください。
          </p>
          <section>
            <h2>1ミリ単位のサイズオーダー商品を、お客様にご提案いただけます。</h2>
            <div class="description_with_img">
              <img :src="getImage('top/corpprice/01_design.webp')">
              <div>
                <p>
                  収納家具を1mm単位でサイズオーダーが可能ですので、
                  お客様からの『カウンターテーブル下の収納スペースにピッタリサイズの壁面収納が欲しい！』
                  『部屋の間取りに合わせた食器棚（カップボード）が欲しい』という要望にお応えするために、mm/styleをご活用ください。
                </p>
              </div>
            </div>
          </section>
          <section>
            <h2>国内工場とシステム連携、高品質な収納家具をお手頃価格で提供</h2>
            <p>
              既製品の収納家具では、本当の意味で住み心地を良くする住居空間の提案を、お客様にすることはできません。しかしながら、
              「フルオーダーの家具はいいけど、価格が高くて」というお客様が多いことも事実です。<br>
              mm/styleは単なるプランニングサイトではなく、独自の特許取得済みのシステムにて、工場と直接データ連携がされております。<br>
              作図作業や見積り積算作業、加工データ作成作業などが全て自動化されているため、通常は人が膨大な時間をかけて行う中間工程がありません。<br>
              そのために、実績の豊富な国内工場での生産でありながら、お手軽な価格のオーダー家具を提供することが可能となっております。
            </p>
            <img :src="getImage('top/corpprice/02-02_automation.webp')">
          </section>
          <section>
            <h2>法人会員登録するとこんなに便利！</h2>
            <div class="procedure_with_img member_benefits">
              <div>
                <h3>① 法人会員限定価格での商品購入</h3>
                <img :src="getImage('top/corpprice/04-01_special.webp')">
                <p>
                  法人会員様限定の割引価格にて商品をご購入いただけるようになります。
                </p>
              </div>
              <div>
                <h3>② メールマガジンでお得な情報をお届け</h3>
                <img :src="getImage('top/corpprice/04-03_mail.webp')">
                <p>
                  クーポンや新商品、キャンペーンの情報などをいち早くお届けいたします。
                </p>
              </div>
              <div>
                <h3>③ カスタマイズ情報の保存</h3>
                <img :src="getImage('top/corpprice/04-04_save.webp')">
                <p>
                  カスタマイズ中の商品情報を保存しておくことができます。
                </p>
              </div>
              <!-- <div>
                <h3>⑤ ご注文時の情報入力がスムーズに</h3>
                <img :src="getImage('top/corpprice/04-05_smooth.webp')">
                <p>
                  ここに説明文が入ります。
                </p>
              </div> -->
              <div>
                <h3>④ オーダー家具営業ノウハウのご提供</h3>
                <img :src="getImage('top/corpprice/04-06_knowhow.webp')">
                <p>
                  サービスの活用方法について、施工事例などを通してご案内いたします。
                </p>
              </div>
            </div>
            <div class="detail_btn btn_pos_center" @click="route('DcOrderSignIn')">会員登録はこちら 〉〉</div>
          </section>
          <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
          <!-- <section>
            <h2>mm/styleの活用事例について</h2>
            <p>
              実際にmm/style (ミリスタイル) をご活用していただいた事例をご紹介します。
            </p>
            <div class="procedure_with_img3">
              <div>
                <h3>吊戸棚（フロート収納）</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
              <div>
                <h3>食器棚（カップボード）</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
              <div>
                <h3>カウンター下収納</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
              <div>
                <h3>本棚・デスク</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
              <div>
                <h3>テレビボード</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
              <div>
                <h3>棚板</h3>
                <img :src="getImage('common/noimage.png')">
                <div class="detail_btn2" @click="route('DcConstructModel')">施工事例を見る 〉〉</div>
              </div>
            </div>
          </section> -->
          <!-- <section>
            <h2>mm/styleが選ばれる3つの理由</h2>
            <p>
              地場のオーダー家具業者様に見積りを依頼された時、「３日経っても返事がこない・・・」といった経験はございませんか？従来のオーダー家具は、
              その都度設計や見積り積算を行いますから、時間もかかってしまいます。<br>
              mm/styleでは、カスタマイズ入力後、数秒で意匠図面と価格をご確認いただけます。すぐにお客様に価格提示ができますので、営業機会ロスが「ゼロ」になります。<br>
              他にも、mm/styleが選ばれる理由はいくつかございます。
            </p>
            <dd-reason-table />
            <dd-reason />
          </section> -->
          <!-- <section>
            <h2>お客様からいただいた声</h2>
            <div class="detail_btn btn_pos_center" @click="route('DcCategory')">商品カテゴリを見る 〉〉</div>
          </section> -->
          <section>
            <h2>ご注文方法は？</h2>
            <p>mm/style (ミリスタイル) は、たった3ステップで別注収納が注文できます。</p>
            <img :src="getImage('top/payment_guide/00_flow.webp')">
            <p>ご注文までの一連の作業が、サイト内で完結するので、必要になったその時に、何時でもご利用していただけます。 また、ご注文いただいた家具は、弊社システムと製造連携している機械化された工場で生産を行いますので、高いサービス品質でありながら低価格・短納期でご提供可能となります。</p>
            <div class="detail_btn2 btn_pos_center" @click="route('DcPaymentGuide')">購入ガイドはこちら 〉〉</div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DDReasonTable from '../components/top/DcSelectReasonTable'
import DDReason from '../components/top/DcSelectReason'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-reason-table': DDReasonTable,
    'dd-reason': DDReason,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcSpecialPrice',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'specialPrice', key: 'dcSpecialPrice', title: '特別仕切り価格のご案内', route: 'DcSpecialPrice'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    }
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSpecialPrice.vue